<template>
  <div class="preparare-formule">
    <div class="container-fluid px-0">

      <banner></banner>

      <div class="container">
        <div class="container container-fixed">
          <div class="position-relative single-arrow">
            <img class="arrow-left" src="../assets/images/left-btn.png"
                 @click="$router.push({ path: 'formula-lapte-praf-aptamil' })">
          </div>
        </div>
      </div>
      <section class="pt-30">
        <div class="produse">
          <div class="container text-center">
            <div>
              <p class="title-ap">Iată cum poți prepara formula de<br/> lapte praf rapid și ușor</p>
              <p class="p-blue">Mai mult, ți-am pregătit și câteva trucuri pe care să le pui în practică, ca tu să devii expert în prepararea formulei. 😉</p>
              <p class="p-blue">Dacă ești deja expert în prepararea unei alte formule de lapte, dar vrei să treci la Aptamil<sup>®</sup> NUTRI-BIOTIK<sup>™</sup>, noi te putem ajuta. Află mai multe!</p>
            </div>

          </div>
        </div>
      </section>

      <div class="services-left accordion prepare-accordion" id="servicesAccordion2">

        <div class="col-lg-12 col-md-12 col-feature row-eq-height mx-auto">
          <div class="feature row-eq-height py-3 question-content ripple riple-service" feature-border="1">
            <div class="feature-content">
              <div data-toggle="collapse" href="#collapseServicesOne" role="button" aria-expanded="false" aria-controls="collapseServicesOne" style="display: flex;align-items: center;">
                <h5 class="feature-mobile-title prepare-title">Pașii de preparare a formulei de lapte praf Aptamil</h5>
                <i class="services-arrow"></i>
              </div>
              <div class="collapse" id="collapseServicesOne" data-parrent="#servicesAccordion2" style="">
                <div class="pt-5 prepare-video">
                  <ul class="details-list">
                    <li><strong>1.</strong> Spală-te bine pe mâini, sterilizează toate ustensilele utilizate în prepararea laptelui și asigură-te că marginea ambalajului este curată.</li>
                    <li><strong>2.</strong> Fierbe apa potabilă pentru prepararea laptelui timp de 5 minute, apoi lasă la răcit până la cca 40°C. Toarnă în recipientul pregătit (biberon/cănuță) cantitatea de apă fiartă şi răcită, necesară conform dozării pentru o masă.</li>
                    <li><strong>3.</strong> Dozează pudra cu linguriţa din capacul ambalajului, nivelată cu ajutorul marginii din interiorul cutiei. Adaugă pudra conform tabelului de dozare în recipientul pregătit (biberon/cănuță).</li>
                    <li><strong>4.</strong> Închide recipientul şi agită vertical și viguros timp de 10 secunde. Este foarte important să respecți modalitatea și timpul de agitare pentru a dizolva corect pudra.</li>
                    <li><strong>5.</strong> Verifică pe încheietura mâinii tale temperatura laptelui preparat (cca 37°C).</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-12 col-md-12 col-feature  row-eq-height mx-auto">
          <div class="feature row-eq-height question-content py-3 ripple" feature-border="2">
            <div class="feature-content">
              <div data-toggle="collapse" href="#collapseServicesTwoo" role="button" aria-expanded="false" aria-controls="collapseServicesTwoo" style="display: flex;align-items: center;">
                <h5 class="feature-mobile-title prepare-title">Trucuri utile de preparare</h5>
                <i class="services-arrow"></i>
              </div>
              <div class="collapse" id="collapseServicesTwoo" data-parrent="#servicesAccordion2" style="">
                <div class="dots-left">
                  <slider></slider>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-12 col-md-12 col-feature row-eq-height mx-auto">
          <div class="feature question-content row-eq-height py-3 ripple" feature-border="3">
            <div class="feature-content ">
              <div data-toggle="collapse" href="#collapseServicesThreee" role="button" aria-expanded="false" aria-controls="collapseServicesThreee" style="display: flex;align-items: center;">
                <h5 class="feature-mobile-title prepare-title">Descoperă cum poți face trecerea la formula de lapte Aptamil<sup>®</sup> NUTRI-BIOTIK<sup>™</sup></h5>
                <i class="services-arrow"></i>
              </div>
              <div class="collapse" id="collapseServicesThreee" data-parrent="#servicesAccordion2">
                <section class="descopera-formula">
                  <section class="trecere-formula">
                    <div class="bk-dark"></div>
                    <div class="container">
                      <div class="row mx-0">
                        <div class="col-lg-10 offset-lg-1">
                          <p>Exemplu de trecere </p>
                          <span>Pentru o cantitate de 180 ml apă și 6 măsuri de pudră de formulă de lapte, vei folosi 5 măsuri din formula curentă și 1 măsură din formula de lapte praf Aptamil<sup>®</sup> NUTRI-BIOTIK<sup>™</sup>, timp de 3 zile.<br><br>
                            Continuă înlocuirea unei măsuri din formula de lapte praf actuală cu formula de lapte praf Aptamil<sup>®</sup> NUTRI-BIOTIK<sup>™</sup> o dată la trei zile, conform schemei de mai jos:</span>
                        </div>
                      </div>

                    </div>
                  </section>
                  <section class="masura-formula">

                    <masura-formula></masura-formula>

                  </section>
                </section>
              </div>
            </div>
          </div>
        </div>
      </div>


      <section>


        <div class="container" style="display: none">
          <prospetime></prospetime>
          <div class="collapse" id="trickList">
            <temperatura></temperatura>

            <ordine></ordine>

            <amestecare></amestecare>

            <mixare></mixare>
          </div>
          <div class="text-center">
            <a class="more-mobil" data-toggle="collapse" href="#trickList" role="button"
               aria-expanded="false" aria-controls="trickList" @click="actionTricks()">
              <span v-if="!show_more">Vezi mai multe <img src="../assets/images/img-down.svg"></span>
              <span v-else>Vezi mai puține<img src="../assets/images/img-up.svg"> </span>
            </a>
          </div>
        </div>
      </section>


      <section>
        <div style="overflow: hidden">
          <div class=" position-relative">
            <div class="banner-preparare mt-4"></div>
          </div>
        </div>
      </section>


      <section class="question intrebari-frecvente">
        <div>
          <h2>Întrebări frecvente</h2>
        </div>
        <div class="services-left accordion" id="servicesAccordion">
          <div class="col-lg-8 col-feature  row-eq-height mx-auto">
            <div class="feature row-eq-height mb-4 ripple collapsed" feature-border="2"
                 data-toggle="collapse" href="#collapseServicesTwo" role="button" aria-expanded="false"
                 aria-controls="collapseServicesTwo">
              <div class="feature-content ft2">
                <div>
                  <p class="subheader">ETAPĂ NOUĂ DE VÂRSTĂ</p>
                  <p>Copilul meu va intra curând într-o nouă etapă de vârstă. Trecerea se va face și în acest caz
                    treptat, chiar daca este vorba despre același producător?</p>

                </div>
                <div class="collapse" id="collapseServicesTwo" data-parrent="#servicesAccordion"
                     style="">
                  <p class="blue2">Dacă vei continua cu formula de lapte a aceluiași producător, trecerea se poate face
                    brusc sau treptat. Recomandarea este ca trecerea să fie făcută dintr-odată. Nu este nevoie de o
                    trecere treptată decât dacă observi că bebe este reticent la eventuale diferențe de gust/miros.
                    Aceste diferențe sunt normale, se datorează valorilor nutriționale adaptate fiecărei vârste,
                    obținute prin ajustarea unor cantități din mixul de ingrediente. </p>

                </div>
              </div>
              <i class="services-arrow"></i>
            </div>
          </div>
          <div class="col-lg-8 col-feature   row-eq-height mx-auto">
            <div class="feature q collapsed row-eq-height mb-4 ripple" feature-border="3"
                 data-toggle="collapse" href="#collapseServicesThree" role="button"
                 aria-expanded="false" aria-controls="collapseServicesThree">
              <div class="feature-content ft2">
                <div>
                  <p class="subheader">DIVERSIFICAREA ȘI SCHIMBAREA FORMULEI</p>
                  <p>Când se trece mai exact de la formula de început la cea de continuare, fix la 6 luni? </p>
                </div>
                <div class="collapse" id="collapseServicesThree" data-parrent="#servicesAccordion">
                  <p class="blue2">Îi poți oferi formula de continuare oricând, între 5 luni și jumătate și 7 luni, în
                    perioadele când nu primește alimente noi și este sănătos. Dacă bebe este mai sensibil și identifică
                    un nou gust al formulei pentru noua etapă, atunci vei face trecerea treptat, combinând cele două
                    formule progresiv, câte o măsură o dată la 2-3 zile.
                  </p>


                </div>
              </div>
              <i class="services-arrow"></i>
            </div>
          </div>
          <div class="col-lg-8 col-feature row-eq-height mx-auto">
            <div class="feature  row-eq-height mb-4 ripple riple-service collapsed" feature-border="1"
                 data-toggle="collapse" href="#collapseServicesFour" role="button" aria-expanded="false"
                 aria-controls="collapseServicesFour">
              <div class="feature-content ft2">
                <div>
                  <p class="subheader">DILUȚIA CORECTĂ</p>
                  <p>Copilul meu împlinește 3 ani în curând. Ce cantitate de apă și câte măsuri trebuie să folosesc la o cănuță de 250 ml?</p>
                </div>
                <div class="collapse" id="collapseServicesFour" data-parrent="#servicesAccordion"
                     style="">
                  <p class="blue2">Diluția este aceeași, indiferent de etapa de vârstă: o măsură de pudră de lapte la 30
                    ml apă. Așadar, dacă acum copilul primește 210 ml apă cu 7 măsuri din pudra de lapte, așa vei
                    prepara și Aptamil<sup>®</sup> NUTRI-BIOTIK<sup>™</sup> 3+. Dacă primește 240 ml apă cu 8 măsuri din pudra de lapte, continuă prepararea
                    în același mod. Este bine să reții că folosind o cănuță de 250 ml, nu se va putea amesteca bine și
                    corect pudra cu apa, decât dacă prepari 180 ml apă cu 6 măsuri pudră de lapte. Pentru amestecare,
                    este nevoie ca deasupra lichidului să rămână suficient spațiu în care să se facă agitarea.</p>
                </div>
              </div>
              <i class="services-arrow"></i>
            </div>
          </div>
          <div class="col-lg-8 col-feature  row-eq-height mx-auto">
            <div class="feature  row-eq-height mb-4 ripple collapsed" feature-border="2"
                 data-toggle="collapse" href="#collapseServicesFive" role="button" aria-expanded="false"
                 aria-controls="collapseServicesFive">
              <div class="feature-content ft2">
                <div>
                  <p class="subheader">DOZAREA CORECTĂ</p>
                  <p>Pentru prepararea a 50, 60, 70 ml de lapte, câte măsuri de lapte sunt necesare? Menționez ca
                    aceasta este completare, mănâncă și la sân.</p>

                </div>
                <div class="collapse" id="collapseServicesFive" data-parrent="#servicesAccordion"
                     style="">
                  <p class="blue2">Dozarea formulei de lapte este standard, o măsură de lapte la 30 ml de apă,
                    indiferent dacă formula se oferă în completare sau este sursă unică de nutriție. Practic, nu se pot
                    prepara 50 sau 70 ml, ci doar 30 ml, 60 ml, 90 ml și tot așa, pentru a păstra diluția corectă. </p>
                  <p class="blue2">Micuțul tău își ajustează apetitul în funcție de nevoile sale, dar prepararea
                    formulei de lapte trebuie făcută conform recomandărilor înscrise pe ambalaj.</p>
                </div>
              </div>
              <i class="services-arrow"></i>
            </div>
          </div>
          <div class="col-lg-8 col-feature row-eq-height mx-auto">
            <div class="feature collapsed row-eq-height mb-4 ripple" feature-border="3"
                 data-toggle="collapse" href="#collapseServicesSix" role="button" aria-expanded="false"
                 aria-controls="collapseServicesSix">
              <div class="feature-content ft2">
                <div>
                  <p class="subheader">SCHIMBAREA PRODUCĂTORULUI</p>
                  <p>Nu sunt mulțumită de formula de lapte actuală și aș dori să trec la o altă marcă. Există
                    contraindicații?</p>
                </div>
                <div class="collapse" id="collapseServicesSix" data-parrent="#servicesAccordion">
                  <p class="blue2">Schimbarea formulei de lapte este un proces care uneori cere răbdare și perseverență,
                    dar, respectând câteva sfaturi simple, trecerea va fi ușoară. În condițiile în care copilul tău este
                    sănătos, nu există contraindicații la trecerea pe o altă formulă de bază. Cu toate acestea, înainte
                    de a-i oferi copilului tău o formulă de lapte praf, cere sfatul medicului sau asistentului
                    medical. </p>
                </div>
              </div>
              <i class="services-arrow"></i>
            </div>
          </div>
        </div>
      </section>

      <section>
        <div class="container ">
          <div class="row ask-experts">
            <div class="col-md-9">
              <div class="row d-flex align-items-center">
                <div class="col-12 col-lg-4 ask-experts-img">
                  <img src="../assets/images/formule-aptamil/call-center.png" alt="call center">
                </div>
                <div class="col-12 col-lg-8 ask-experts-info">
                  <p class="ask-experts-title">Cere sfatul experților</p>
                  <p class="ask-experts-text">Ai nevoie de mai multe informații despre produsele noastre? Cauți sfaturi
                    de preparare sau de tranziție? Contactează-ne!</p>
                </div>
              </div>
            </div>
            <div class="col-md-3">
              <div class="contact-box">
                <a href="tel:021 439 03 45" class="inline-icon-text">
                  <div class="contact-box-h">
                    <div class="contact-experts-icons">
                      <img src="../assets/images/formule-aptamil/phone.png"
                           alt="Telefon" class="img-fluid">
                    </div>
                    <div class="desktop-version">
                      <p class="">Telefon</p>
                    </div>
                    <div class="mobile-version">
                      <p class="0">Telefon</p>
                    </div>
                  </div>
                </a>
                <a href="mailto:expert@aptanutricia.ro" class="inline-icon-text">
                  <div class="contact-box-h">
                    <div class="contact-experts-icons">
                      <img src="../assets/images/formule-aptamil/mail.png"
                           alt="E-mail" class="img-fluid">
                    </div>
                    <div class="desktop-version">
                      <p class="">E-mail</p>
                    </div>
                    <div class="mobile-version">
                      <p class="1">E-mail</p>
                    </div>
                  </div>
                </a>
                <a href="#" class="inline-icon-text" @click="goTo()">
                  <div class="contact-box-h">
                    <div class="contact-experts-icons">
                      <img src="../assets/images/formule-aptamil/site.png"
                           alt="Direct în site" class="img-fluid">
                    </div>
                    <div class="desktop-version">
                      <p class="">Direct <br class="d-block, d-md-none">în site</p>
                    </div>
                    <div class="mobile-version">
                      <p class="2">Întrebări</p>
                    </div>
                  </div>
                </a>
              </div>

            </div>
          </div>
        </div>


      </section>

      <section>
        <div class="container">
          <div class="col-lg-9 offset-lg-1 px-0 pt-30 pb-30">
            <p class="p-gray">FOARTE IMPORTANT<br>Laptele matern este cea mai bună hrană pentru copilul tău, astfel că alăptarea trebuie să dureze o perioadă cât mai îndelungată. Se recomandă alăptarea exclusivă cu lapte matern pentru sugarii cu vârsta de până la 6 luni. Formulele de lapte praf Aptamil<sup>®</sup> NUTRI-BIOTIK<sup>™</sup> se folosesc numai la indicația și sub îndrumarea medicului sau asistentului medical și numai după instruirea mamei privind utilizarea acestora. </p>
          </div>
        </div>
      </section>

    </div>
  </div>
</template>
<script>
import Slider from '../components/PreparareFormule/Slick.vue'
import Banner from '../components/PreparareFormule/Banner.vue'
import MasuraFormula from '../components/PreparareFormule/MasuraFormula.vue'
// import cards from slider
import Prospetime from '../components/PreparareFormule/CardSlick/Prospetime.vue'
import Temperatura from '../components/PreparareFormule/CardSlick/Temperatura.vue'
import Ordine from '../components/PreparareFormule/CardSlick/Ordine.vue'
import Amestecare from '../components/PreparareFormule/CardSlick/Amestecare.vue'
import Mixare from '../components/PreparareFormule/CardSlick/Mixare.vue'

export default {
  components: {
    'slider': Slider,
    'banner': Banner,
    'masura-formula': MasuraFormula,
    // CardSlick
    'prospetime': Prospetime,
    'temperatura': Temperatura,
    'ordine': Ordine,
    'amestecare': Amestecare,
    'mixare': Mixare,
  },
  data() {
    return {
      show_more: false
    }
  },
  methods: {
    actionTricks() {
      if (this.show_more) {
        let top_div = document.getElementById("tricks-aptamil")
            .offsetTop;
        window.scrollTo(0, top_div);
        this.show_more = false
      } else {
        this.show_more = true
      }
    },
    goTo() {
      window.fbq('track', 'Intreaba-Expertii');
      window.gtag('event', 'sent', {'event_category': 'buton-intreaba-expertii'});
      window.open("https://www.aptanutricia.ro/descopera-stiinta-nutricia/mamicile-intreaba", '_blank');
    }
  }
}
</script>

<style lang="scss">
.feature .collapsed .feature-arrow,
.feature .collapsed .services-arrow {
  transform: rotate(0deg);
}

ul.details-list {
  list-style: none;
  padding: 0;
}

ul.details-list li {
  color: #17479E;
  padding-bottom: 5px;
}

#servicesAccordion .feature.collapsed .feature-content .subheader, .services-left .feature .subheader {
  font-weight: 800 !important;
  margin-bottom: 10px !important;
}


.descopera-formula .bk-blue-light {
  background: #F2F0ED !important;

  span {
    color: #17479E !important;
  }
}

#collapseServicesTwo .slick-initialized .slick-slide {
  margin-right: 10px;
  outline: none;
  width: 340px !important;
}

.ft2, .ft2 p {
  width: 98% !important;
}

.ft2 p {
  font-weight: 500 !important;
}

.feature-arrow, .services-arrow {
  position: absolute !important;
  right: 10px;
}

.prepare-accordion {
  .services-arrow {
    background: url("../assets/images/preparare-formule/btn.png") !important;
  }

  .feature {
    background: white !important;
    border-top: 1px solid #EFEFEF;
    max-width: 940px;
    margin: auto;


    .feature-content {
      background: white;

      .prepare-title {
        font-size: 26px;
        color: #17479E !important;
        font-weight: 600;
      }
    }

  }

}

.p-blue {
  font-size: 18px;
  color: #17479E;
  max-width: 744px;
  margin: auto;
  margin-bottom: 16px;
}

.pt-30 .produse {
  margin: 60px 0;
}

.anchor {
  display: block;
  height: 50px;
  margin-top: -100px;
  visibility: hidden;
}

.btn-blue-dark {
  color: #fff;
  font-size: 16px;
  font-weight: 700;
  background: #17479E;
  border-radius: 10px;
  height: 50px;
  width: 100%;

}

.btn-blue-drak:hover {
  color: #fff;
}

.banner-preparare {
  height: 400px;
  background: url("../assets/images/preparare-formule/banner-1690.png");
  background-repeat: no-repeat;
  background-position: center center;
  max-width: 940px;
  margin: auto;
  background-size: cover;
}


.descopera-formula .bk-blue-light p {
  font-size: 20px;
  font-weight: 700;
  margin-bottom: 0;
}

.descopera-formula .bk-blue-light span {
  font-size: 16px;
  font-weight: 400;
  color: #009FE3;
}

.descopera-formula .bk-blue-light {
  background: #F1F8FF;
  border-radius: 20px;
  padding: 20px;
  margin: 15px 0;
  text-align: left;
}

.trecere-formula {
  margin: 35px 0;
  position: relative;
}

.trecere-formula .container {
  background: #C4E4F9;
  padding: 35px 0;
}

.trecere-formula .bk-dark {
  position: absolute;
  right: 0;
  height: 100%;
  background: #C4E4F9;
  width: 50%;
  top: 0;
}

.trecere-formula p {
  font-size: 18px;
  font-weight: 700;
  color: #17479E;
}

.trecere-formula span {
  font-size: 16px;
  font-weight: 500;
  color: #17479E;
}

.masura-formula p {
  font-size: 14px;
  font-weight: 500;
  color: #17479E;
  display: flex;
}

.masura-formula .legend p {
  display: block;
}

.dot.light {
  height: 18px;
  width: 18px;
  background-color: #009FE3;
  border-radius: 50%;
  display: inline-block;
  margin-right: 15px;
}

.dot.dark {
  height: 18px;
  width: 18px;
  background-color: #17479E;
  border-radius: 50%;
  display: inline-block;
  margin-right: 15px;
}

.carouselOne .carouselContainer .owl-theme .owl-nav.disabled + .owl-dots {
  position: absolute !important;
  bottom: 0;
  left: 9%;
}

.border-light {
  display: flex;
  font-size: 14px;
  font-weight: 500;
  color: #17479E;
  align-items: center;
}

.border-light .dot {
  margin-right: 5px;
}

.border-light p {
  border: 1px solid #009FE3;
  border-radius: 25px;
  padding: 9px;
  margin-bottom: 0;

}

.border-light .pr-4 {
  width: 96px;
}

@media only screen and (max-width: 1440px) {
  .banner-preparare:after {
    content: url("../assets/images/preparare-formule/banner-1200.png");
  }
}

@media only screen and (max-width: 992px) {
  .carouselOne .carouselContainer .owl-theme .owl-nav.disabled + .owl-dots {
    left: 50%;
    transform: translateX(-50%);
  }

  .bk-blue-light2 {
    margin-bottom: 15px !important;
  }

  //.dots-left .carouselOne .carouselContainer .owl-theme .owl-nav.disabled + .owl-dots {
  //  left: 0;
  //  bottom: 0;
  //}

  .anchor {
    display: block;
    height: 100px;
    margin-top: -100px;
    visibility: hidden;
  }
  .nut-banner h2 {
    font-size: 16px;
  }
  .nut-banner h1 {
    line-height: 36px !important;
  }
  .nut-banner h1 span br {
    display: none;
  }
  .nut-banner .border-white {
    width: 120px;
  }
  .btn-blue-dark {
    font-size: 14px;
    line-height: 14px;
  }
  .title-ap {
    font-size: 24px;
    font-weight: 700;
    color: #17479E;
    line-height: 24px;
    text-align: left;
  }
  .nut-banner h1 {
    line-height: 30px;
  }
  .banner-preparare {
    background-image: url("../assets/images/preparare-formule/preparare.png");
    background-repeat: no-repeat;

  }
  .banner-preparare:after {
    content: '';
  }
  .descopera-formula {
    margin-top: 30px !important;
  }
  .descopera-formula .title-ap {
    padding-left: 0;
  }
  .descopera-formula p {
    text-align: left;
  }
  .descopera-formula .title-ap br,
  .descopera-formula p br {
    display: none;
  }
  .descopera-formula .bk-blue-light {
    min-height: auto;
    max-height: 100%;
  }
  .pt-1 {
    padding-top: 5px;
  }
  .grafic-formula .pt-4 {
    padding-top: 0 !important;
  }
  .produse {
    margin-top: 30px;
  }
  .masura-formula {
    margin-top: 15px !important;
  }
  #app .preparare-formule .container-fixed .arrow-left {
    height: 60px;
    right: 15px;
    top: 0;
  }
  .border-light {
    justify-content: center
  }
}

@media only screen and (max-width: 768px) {
  .prepare-accordion .feature .feature-content .prepare-title {
    font-size: 18px;
    line-height: 26px;
    margin-bottom: 10px;
    padding-right: 10px;
  }
  .trecere-formula {
    background: #C4E4F9;
  }
  .ask-experts-info {
    text-align: center;

    .ask-experts-title {
      font-size: 26px;
      width: 100%;
    }
  }
}

@media screen and (max-width: 526px) {
  //.owl-theme .owl-nav.disabled + .owl-dots {
  //  position: absolute;
  //  left: 5% !important;
  //  width: 100% !important;
  //}

  .intrebari-frecvente {
    margin-top: 10px !important;
  }
  .pt-30 .produse {
    margin: 30px 0;
  }
  .question-content {
    margin: 0 !important;
    padding: 0 !important;
  }
  .prepare-accordion .services-arrow {
    position: absolute;
    right: 0;
  }
}

@media screen and (min-width: 992px) and (max-width: 1199px){
  .part-img img{
    width: 135%;
    max-width: 135%;
    margin-left: -19%;
  }
}

@media screen and (min-width: 1200px){
  .part-img img{
    width: 150%;
    max-width: 150%;
    margin-left: -35%;
  }
}
</style>
